// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"index-module--SectionTitle--2Jm8J"};